import { render } from "./StudentList.vue?vue&type=template&id=320e83be&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"

import "./StudentList.vue?vue&type=style&index=0&id=320e83be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320e83be"]])

export default __exports__